<template>
    <card class="card cardShadow-light mb-4" title="Datos de despacho">
            <span class="mini-msj">(*) Requerido</span>
        <div class="row">
            <div class="form-group col-md-4">
                <label for="">Nombre de Empresa/Cliente: (*)</label>
                <input type="text" :class="'form-control '+(enterpriseMessage?'is-invalid':'')" v-model="create.enterpriseName" />
                <span class="text-danger" v-if="errors.EnterpriseName"> {{ errors.EnterpriseName[0] }}</span>
                <div class="text-danger small text-right">{{ enterpriseMessage }}</div>
            </div>
            <div class="form-group col-md-4">
                <label for="">País (*)</label>
                <v-select :class="(countryMessage?'is-invalid-select':'')" :required="!country" :options="countries" v-model="country" @input="getCities"> 
                    <span slot="no-options">No se encontraron Países</span>
                </v-select>
                <div class="text-danger small text-right">{{ countryMessage }}</div>
            </div>
            <div class="form-group col-md-4">
                <div class="row">
                    <div class="col-md-10">
                        <label for="">Ciudad (*)</label>
                        <v-select :class="(cityMessage?'is-invalid-select':'')" :options="cities" v-model="city"  > 
                            <span slot="no-options">No se encontraron Ciudades</span>
                        </v-select>
                        <span class="text-danger" v-if="errors.CityId"> {{ errors.CityId[0] }}</span>
                        <div class="text-danger small text-right">{{ cityMessage }}</div>
                    </div>
                    <div class="col-md-2 text-right" style="margin-top: 34px;">
                        <button @click="showAddCityModal" title="Agregar Ciudad" :disabled="!country.code" class="btn btn-sm btn-success"><i class="fa fa-plus"></i></button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-4">
                <label for="">Código Postal</label>
                <input type="text" class="form-control" v-model="create.postalCode"/>
                <span class="text-danger" v-if="errors.PostalCode"> {{ errors.PostalCode[0] }}</span>
            </div>           
            <div class="form-group col-md-4">
                <label for="">Dirección (*)</label>
                <input type="text" :class="'form-control '+(addressMessage?'is-invalid':'')" v-model="create.address" />
                <span class="text-danger" v-if="errors.Address"> {{ errors.Address[0] }}</span>
                <div class="text-danger small text-right">{{ addressMessage }}</div>
            </div>   
            <div class="form-group col-md-4">
                <label for="">Segunda Dirección / Referencia</label>
                <input type="text" class="form-control" v-model="create.secondAddress" />
                <span class="text-danger" v-if="errors.SecondAddress"> {{ errors.SecondAdress[0] }}</span>
            </div>      
        </div>
        <div class="row">
            <div class="form-group col-md-4">
                <label for="">Contacto (Sr./Sra) (*)</label>
                <input type="text" :class="'form-control '+(contactMessage?'is-invalid':'')" v-model="create.contactName"/>
                <span class="text-danger" v-if="errors.ContactName"> {{ errors.ContactName[0] }}</span>
                <div class="text-danger small text-right">{{ contactMessage }}</div>
            </div>
             <div class="form-group col-md-4">
                <label for="">Teléfono (*)</label>
                <input type="text" :class="'form-control '+(phoneMessage?'is-invalid':'')" v-model="create.phoneNumber"/>
                <span class="text-danger" v-if="errors.PhoneNumber"> {{ errors.PhoneNumber[0] }}</span>
                <div class="text-danger small text-right">{{ phoneMessage }}</div>
            </div>  
            <div class="form-group col-md-4">
                <label for="">Email</label>
                <input type="mail" class="form-control" v-model="create.email" />
                <span class="text-danger" v-if="errors.Email"> {{ errors.Email[0] }}</span>
            </div> 
        </div>
        <div class="row">
            <div class="form-group col-md-12">
                <label for="">Observaciones</label>
                <textarea class="form-control" v-model="create.remarks"></textarea>
                <span class="text-danger" v-if="errors.Remarks"> {{ errors.Remarks[0] }}</span>
            </div>
        </div>
        <button :disabled="btnDisabledDispatch" v-if="!dispatch" type="button" class="btn btn-success btn-block" @click.prevent="save" title="Guardar Despacho">
            <i class="fa fa-save"></i> Guardar
        </button>
        <button :disabled="btnDisabledDispatch" v-if="dispatch && dispatch.id" type="button" class="btn btn-primary btn-block" @click.prevent="save">
            <i class="fa fa-save"></i> Actualizar
        </button>
        <modal id="addCity" title="Registrar Ciudad">
            <city-form :newCity="newCity" :country="country" @pressOk="saveCity"></city-form>
        </modal>
    </card>
</template>

<script>
import {Get, Post} from '../../../helper/axios'
import toastr from 'toastr';
import $ from "jquery";

export default {
    props: ['id', 'dispatch'],
    data() {
        return {
            apiUrl: this.$store.getters.apiUrl,
            create: {
                enterpriseName: '',
                address: '',
                secondAddress: '',
                phoneNumber: '',
                contactName: '',
                email: '',
                postalCode: '',
                remarks: ''
            },
            countries: [],
            cities:[],
            country: {},
            city: {},
            cityId: null,
            Get,Post,
            errors: {},
            newCity: {}
        }
    },
    watch: {
        dispatch: function () {
            this.setData();
        }
    },
    created() {
        this.getCountries();
        this.setData();
    },
    methods: {
        getCountries() {
            this.Get(`${this.apiUrl}v1/countries`, (res) => {
                res.data.forEach(element => {
                    this.countries.push({code: element.id, label: element.name});
                });
            })
        },
        getCities() {
            let id = this.country.code;
            this.cities = [];
            this.city = '';
            if (id) {
                this.Get(`${this.apiUrl}v1/countries/cities?id=${id}`, (res) => {
                    res.data.forEach(item => {
                        this.cities.push({code: item.id, label: item.name});
                        if (this.cityId && item.id == this.cityId) {
                            this.city = {code: item.id, label: item.name};
                        }
                    })
                })
            }
        },
        async getAsyncCities() {
            let id = this.country.code;
            this.cities = [];
            this.city = '';
            if (id) {
                try {
                    const res = await new Promise((resolve, reject) => {
                        this.Get(`${this.apiUrl}v1/countries/cities?id=${id}`, (res) => {
                            if (res.error) {
                                reject(res.error);
                            } else {
                                resolve(res); 
                            }
                        });
                    });

                    res.data.forEach(item => {
                        this.cities.push({code: item.id, label: item.name});
                        if (this.cityId && item.id == this.cityId) {
                            this.city = {code: item.id, label: item.name};
                        }
                    });
                } catch (error) {
                    console.error('Error al obtener las ciudades:', error);
                }
            }

        },
        setData(){
            if (this.dispatch) {
                this.create =  {
                    enterpriseName: this.dispatch.enterpriseName,
                    address: this.dispatch.address,
                    secondAddress: this.dispatch.secondAddress,
                    phoneNumber: this.dispatch.phoneNumber,
                    contactName: this.dispatch.contactName,
                    postalCode: this.dispatch.postalCode,
                    remarks: this.dispatch.remarks,
                    email: this.dispatch.email
                }
                this.country = {code: this.dispatch.country.id, label: this.dispatch.country.name};
                this.cityId = this.dispatch.cityId;
                this.getCities();
            }
        },
        save() {
            if (this.city.code) {
                this.create.cityId = this.city.code;
                this.create.RequestCommercialId = this.id;
                if (this.dispatch) {
                    this.create.id = this.dispatch.id;
                }
                this.Post(`${this.apiUrl}v1/dispatchs`, this.create, (res) => {
                    toastr.success('Datos registrados correctamente');
                    this.$emit('setDispatch', res.data);
                })
            }
        },

        async saveCity() {
            if (this.newCity) {
                this.$store.commit("setLoading", true);
                this.Post(`${this.apiUrl}v1/countries/addCity`, this.newCity, async (res) => {
                    this.$store.commit("setLoading", false);
                    toastr.success('Ciudad registrada correctamente');
                    await this.getAsyncCities();

                    this.city = {
                        code: res.data.id, 
                        label: res.data.name
                    };

                    this.newCity = {};
                    $('#addCity').modal('hide');
                });
            }
        },
        showAddCityModal() {
            if (this.country) {
                $('#addCity').modal('show');
            }
           
        },
    },
    computed: {
        enterpriseMessage(){
            let message = ''
            if(!this.create.enterpriseName)
                message = 'Agregue Empresa'
            return message    
        },
        countryMessage(){
            let message = ''
            if (!this.country || Object.entries( this.country ).length === 0)
                message = 'Agregue País'
            return message    
        },
        cityMessage(){
            let message = ''
            if (!this.city || Object.entries( this.city ).length === 0)
                message = 'Agregue Ciudad'
            return message    
        },
        addressMessage(){
            let message = ''
            if(!this.create.address)
                message = 'Agregue Dirección'
            return message    
        },
        contactMessage(){
            let message = ''
            if(!this.create.contactName)
                message = 'Agregue Contacto'
            return message    
        },
        phoneMessage(){
            let message = ''
            if(!this.create.phoneNumber)
                message = 'Agregue teléfono'
            return message    
        },
        isValid(){
            return !this.enterpriseMessage &&  
                    !this.countryMessage &&  
                    !this.cityMessage &&
                    !this.addressMessage &&
                    !this.contactMessage &&
                    !this.phoneMessage
        },
        btnDisabledDispatch(){
            if (this.isValid) 
                return false;
            else   
                return true;
        }
    }

}
</script>